import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { installSupabaseTrafficTracker } from './lib/supabaseTrafficTracker';

// Start tracking Supabase traffic immediately so the admin monitor
// shows data accumulated from app load, not just from when the tab opens.
installSupabaseTrafficTracker();

// Force clean module resolution
const container = document.getElementById("root");
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
